module.exports = __webpack_public_path__ + "static/media/image6.fa83d28b.png";